<template>
  <div id="header">
    <div class="mycontainer">
      <div class="md:flex md:justify-between md:items-center">
        <router-link to="/" class="logo md:ml-20" hreflang="en-MY"></router-link>
        <div class="t13 md:ml-auto text-black disposition-info">
          <user-top-desktop :voucher="voucher"></user-top-desktop>
          <template v-if="!voucher">
            <span class="header-location hidden-xs hidden-sm md:border-l  md:pl-10 ml-10 text-black hidden-1150">
              <img src="https://static.phdvasia.com/my/icons/icon-location.svg" class=" mr-10 opacity-50 " width="13">
                <div v-if="$i18n.locale == $const.LANG_JP" class="order-info-top">
                  <router-link to="/" class="cursor-pointer" hreflang="en-MY">
                      <label style="" class="order-type-text border-b cursor-pointer">
                          {{deliveryInfo.addressInfo}}
                      </label>
                  </router-link>
                  <span
                    class="t14">{{ deliveryInfo.orderType == 'delivery' ? $t( 'delivery_to') : $t( 'take_away')}}</span>
                </div>
                <div v-else class="order-info-top">
                  <router-link to="/" class="cursor-pointer" hreflang="en-MY">
                      <span
                        style=""
                        class="order-type-text cursor-pointer" v-if="deliveryInfo.orderType">
                          {{ deliveryInfo.orderType == 'delivery' ? $t( 'delivery_to') : $t( 'take_away')}}
                      </span>
                  </router-link>
                  <router-link to="/" class="cursor-pointer" hreflang="en-MY">
                      <label style="" class="order-type-text border-b cursor-pointer">
                          {{deliveryInfo.addressInfo}}
                      </label>
                  </router-link>
                </div>

              <!--<router-link to="/" class="cursor-pointer">
                  <label
                    style=""
                    class="order-type-text border-b cursor-pointer" v-if="deliveryInfo.orderType">
                      {{$t(deliveryInfo.orderType)}}
                  </label>
              </router-link>
              <span v-if="deliveryInfo.orderType == 'delivery'">{{$t('to')}}</span>
              <span v-else>{{$t('from')}}</span>
              <router-link to="/" class="cursor-pointer">
                  <label
                    style=""
                    class="order-type-text border-b cursor-pointer">
                      {{deliveryInfo.addressInfo}}
                  </label>
              </router-link>-->

            </span>
            <span class="header-time xs-ml-10 cursor-pointer md:border-l md:inline md:pl-10 ml-10"
                  v-if="deliveryInfo.orderType"
                  @click="showAsapPopup">
                          <img class="desktop-only" src="https://static.phdvasia.com/my/icons/clock.svg" width="14">
                          <img class="mobile-only" v-if="deliveryInfo.orderType == $const.DELIVERY.toLowerCase()" src="https://static.phdvasia.com/my/icons/Delivery.svg" width="30">
                          <img class="mobile-only" src="https://static.phdvasia.com/my/icons/Takeaway.svg" width="30" v-else>
                          <span class="order-datetime-text border-b text-black" v-html="collectionTime"></span>
                  <!--<span v-if="$disposition.getByKey(this, 'advanceOrder', 0) === 0"-->
                        <!--class="order-datetime-text border-b">-->
                          <!--{{$t('checkout.waiting_time', {min: getWaitingTime(this)})}}-->
                  <!--</span>-->
            </span>
            <span v-else></span>

            <div class="header-basket cursor-pointer show-basket">
              <user-top-mobile></user-top-mobile>
            </div>
         </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import ASAPPopup from '../popup/OrderASAP.vue'
  import UserTopMobile from '../partials/UserTopMobile'
  import UserTopDesktop from '../partials/UserTopDesktop'
  import moment from 'moment-timezone'

  export default {
    components: {
      UserTopMobile,
      UserTopDesktop
    },
    props: ['voucher'],
    destroyed () {
      this.$root.$off('onReInitHeader')
      this.$root.$off('collectionTimeUpdate')
      this.$root.$off('cartUpdate')
      this.$root.$off('loadposition')
    },
    mounted: function () {
      var vm = this
      this.$disposition.init(this)
      this.$cart.init(this)
      this.initdata()
      this.$root.$on('cartUpdate', () => {
          vm.$cart.init(vm)
        })
      this.$root.$on('collectionTimeUpdate', () => {
        vm.collectionTime = vm.getTimePicker(vm, true)
      })
      this.mode = this.$session.get('modeView') || 'grip'
      this.$root.$on('onReInitHeader', () => {
        vm.initdata()
      })

      this.$root.$on('loadposition', () => {
        vm.deliveryInfo = this.getDeliveryInfo(this)
      })

    },
    data() {
      return {
        mode: 'grip',
        deliveryInfo: this.getDeliveryInfo(this),
        collectionTime: '',
        orderType: null,
        nowHour : '',
        timezone : ''
      }
    },
    methods: {
      initdata() {
        this.collectionTime = this.getTimePicker(this, true)
        this.deliveryInfo = this.getDeliveryInfo(this)
      },
      showAsapPopup () {
        this.$modal.show(ASAPPopup, {parentlink: this.getCurrentPath()}, {class: ''})
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/partials/HeaderMain.vue